import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { formatRewardName } from '@utils/quest/formatRewardName';

import { useModals } from '@shared/contexts';

import { useQueryGetMe } from '@hooks/api/user/use-query-me';
import useGetPointsIcon from '@hooks/use-get-points-icon';

import { QuestType } from '@types';

import { Button } from '@components/button';
import { Modal } from '@components/modal';

import { ModalName } from '../types';
import * as Styled from './quest-details-modal.styled.ts';

export interface QuestDetailsModalData {
	quest: QuestType;
}

const QuestDetailsModal = () => {
	const { t } = useTranslation();
	const { isModalOpen, closeModal, getModalData, openModal } = useModals();
	const { data: user } = useQueryGetMe();
	const PointsIcon = useGetPointsIcon();

	const modalData = getModalData<QuestDetailsModalData>(ModalName.QUEST_DETAILS);
	const quest = modalData?.quest;

	const isAuthenticated = !!user?.pm_id;

	const handleLoginClick = () => {
		openModal(ModalName.LOGIN);
		closeModal();
	};

	const handleStartQuest = () => {
		if (!isAuthenticated) {
			handleLoginClick();
			return;
		}

		if (!quest?.url) {
			return;
		}

		window.open(quest.url, '_blank');
		closeModal();
	};

	const handleCloseModal = () => {
		closeModal();
	};

	if (!quest) {
		return null;
	}

	const rewardName = formatRewardName(quest.rewards?.[0]?.name || '');

	return (
		<Modal
			isOpen={isModalOpen(ModalName.QUEST_DETAILS)}
			closeModal={handleCloseModal}
			hasPadding={false}
			backgroundColor='dark'
			title={quest.name || ''}
			titlePosition='center'
		>
			<Styled.Wrapper>
				<Styled.Content>
					<Styled.QuestImage $src={quest.image || ''} />

					<Styled.RewardSection>
						{rewardName}
						{PointsIcon}
					</Styled.RewardSection>

					<Styled.Description dangerouslySetInnerHTML={{ __html: quest.description || '' }} />
				</Styled.Content>

				<Styled.Footer>
					<Button color='dark' onClick={handleCloseModal}>
						{t('close')}
					</Button>
					<Button color='primary' onClick={handleStartQuest}>
						{isAuthenticated ? t('begin_quest') : t('login')}
					</Button>
				</Styled.Footer>
			</Styled.Wrapper>
		</Modal>
	);
};

export { QuestDetailsModal };
